export const AUTH_STORAGE_KEY = "Auth-token";
export const SERVER_URL = "";
export const AUTH_USER = "Auth-User";
export const AUTH_ACCOUNTS = "Auth-Accounts";
export const CSRFTOKEN = "CSRF";
export const INCLUDE_ACCOUNTS = "Include-Accounts";
export const INCLUDE_ALL_ACCOUNTS = "Include-All_Accounts";
export const NOTIFICATIONS = "Notifications";
export const SYSTEM_NOTIFICATIONS = "System_Notifications";
export const IMPORT_DEVICES_MAPPING_COLUMN_FROM_ROOM =
  "Import_Devices_Mapping_Column_Room";
export const IMPORT_DEVICES_MAPPING_COLUMN_FROM_LOCATION =
  "Import_Devices_Mapping_Column_Location";
export const IMPORT_DEVICES_MAPPING_COLUMN_FROM_ACCOUNT =
  "Import_Devices_Mapping_Column_Account";
export const SKIP_IMPORT_MAPPING = "Skip_Import_Mapping";
export const SAVE_IMPORT_MAPPING = "Save_Import_Mapping";
export const IMPORT_ROOMS_MAPPING_COLUMN_FROM_ACCOUNT =
  "Import_Rooms_Mapping_Column_from_account";
export const IMPORT_ROOMS_MAPPING_COLUMN_FROM_LOCATION =
  "Import_Rooms_Mapping_Column_from_location";
export const SKIP_IMPORT_MAPPING_ROOM = "Skip_Import_Mapping_Room";
export const SAVE_IMPORT_MAPPING_ROOM = "Save_Import_Mapping_Room";
export const IMPORT_LOCATIONS_MAPPING_COLUMN =
  "Import_Locations_Mapping_Column";
export const SKIP_IMPORT_MAPPING_LOCATION = "Skip_Import_Mapping_Location";
export const SAVE_IMPORT_MAPPING_LOCATION = "Save_Import_Mapping_Location";
export const FILTERS = "Filters";
export const TICKETS_COUNTS = "Tickets_Counts";
export const GA_COOKIES_CLEARED = "ga_cookies_cleared";
